import React, { useRef } from 'react'
import { Box, Container, IconButton, Typography } from '@material-ui/core'
import Slider from 'react-slick'
import { useIntl } from 'gatsby-plugin-intl'
import EndIconButton from '../EndIconButton'
import Image from '../Image'
import RichText from '../RichText'
import { useStyles } from './HomeSlider.style'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const HomeSlider = ({ data = {} }) => {
  const mainSlider = useRef()
  const textSlider = useRef()
  const { locale } = useIntl()
  const styles = useStyles({ locale })

  const mainSliderSettings = {
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const textSliderSettings = {
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
  }

  const nextSlideHandler = () => {
    mainSlider.current.slickNext()
    textSlider.current.slickNext()
  }
  const prevSlideHandler = () => {
    mainSlider.current.slickPrev()
    textSlider.current.slickPrev()
  }

  return (
    <Container maxWidth="xl" className={styles.root}>
      <IconButton
        className={`${styles.arrowIconButton} ${styles.arrowIconButtonPrev}`}
        onClick={prevSlideHandler}
      >
        <Image {...data.backwardarrow} />
      </IconButton>
      <Box className={styles.sliderContainer}>
        <Box className={styles.sliderWrapper}>
          <Box className={styles.leftSection}>
            <Slider
              asNavFor={textSlider.current}
              ref={mainSlider}
              {...mainSliderSettings}
            >
              {data.slides.map((mainSliderItem, mainSliderIndex) => {
                const imageProps = {
                  ...mainSliderItem.sliderImage?.image,
                  file: mainSliderItem.sliderImageUrl
                    ? {
                        url: mainSliderItem.sliderImageUrl,
                      }
                    : mainSliderItem.sliderImage?.image?.file,
                }
                return (
                  <Image
                    key={`mainSlide-${mainSliderIndex}`}
                    className={styles.mainImage}
                    {...imageProps}
                  />
                )
              })}
            </Slider>
          </Box>

          <Box className={styles.rightSection}>
            <Box className={styles.sliderText}>
              <Slider
                asNavFor={mainSlider.current}
                ref={textSlider}
                {...textSliderSettings}
              >
                {data.slides.map((textSliderItem, textSliderIndex) => (
                  <Box
                    key={`textSlide-${textSliderIndex}`}
                    className="carousel-cell-text"
                  >
                    <Typography className={styles.sliderHeading} variant="h3">
                      {textSliderItem.slideHeading}
                    </Typography>
                    <RichText
                      className={styles.sliderDescription}
                      variant="body1"
                      document={JSON.parse(textSliderItem.slideDescription.raw)}
                    />
                    {textSliderItem.sliderCta && (
                      <EndIconButton
                        link={textSliderItem.sliderCta.link}
                        title={textSliderItem.sliderCta.title}
                      />
                    )}
                  </Box>
                ))}
              </Slider>
            </Box>
          </Box>
        </Box>
      </Box>

      <IconButton className={styles.arrowIconButton} onClick={nextSlideHandler}>
        <Image {...data.forwardarrow} />
      </IconButton>
    </Container>
  )
}

export default HomeSlider
